import {OfferType} from "../../offer/types/OfferType";
import {AdditionalAreaType} from "../../property/utils/get_additional_area_type";
import {IClientUpdatePayload} from "../api/for_you_client";
import {IForYouModal} from "../types/IForYouModal";

export const getUpdateData = (modalState: IForYouModal): IClientUpdatePayload => {
    const additionalCriteria = modalState.additional;
    const regionsData = modalState.regions?.map((region) => region.id);
    const additionalAreas = additionalCriteria?.additional_areas && additionalCriteria.additional_areas;
    const additionalAreaSelected = typeof additionalAreas === "string" ? parseInt(additionalAreas) : 0;

    return {
        regions: regionsData || [],
        additional_areas:
            additionalAreaSelected > 0
                ? additionalAreaSelected === AdditionalAreaType.BALCONY
                    ? [additionalAreaSelected, AdditionalAreaType.LOGGIA]
                    : [additionalAreaSelected]
                : [],
        comments: additionalCriteria?.message || "",
        construction_end_date: additionalCriteria?.date || undefined,
        floors: additionalCriteria?.floor,
        kitchen_type: (additionalCriteria?.kitchen && parseInt(additionalCriteria?.kitchen)) || undefined,
        quarters: additionalCriteria?.quarters || undefined,
        types: modalState.types.length ? modalState.types : [OfferType.FLAT, OfferType.HOUSE]
    };
};
import {OfferType} from "../../offer/types/OfferType";
import {AdditionalAreaType} from "../../property/utils/get_additional_area_type";
import {IClientUpdatePayload} from "../api/for_you_client";
import {IForYouModal} from "../types/IForYouModal";

export const getUpdateData = (modalState: IForYouModal): IClientUpdatePayload => {
    const additionalCriteria = modalState.additional;
    const regionsData = modalState.regions?.map((region) => region.id);
    const additionalAreas = additionalCriteria?.additional_areas && additionalCriteria.additional_areas;
    const additionalAreaSelected = typeof additionalAreas === "string" ? parseInt(additionalAreas) : 0;

    return {
        regions: regionsData || [],
        additional_areas:
            additionalAreaSelected > 0
                ? additionalAreaSelected === AdditionalAreaType.BALCONY
                    ? [additionalAreaSelected, AdditionalAreaType.LOGGIA]
                    : [additionalAreaSelected]
                : [],
        comments: additionalCriteria?.message || "",
        construction_end_date: additionalCriteria?.date || undefined,
        floors: additionalCriteria?.floor,
        kitchen_type: (additionalCriteria?.kitchen && parseInt(additionalCriteria?.kitchen)) || undefined,
        quarters: additionalCriteria?.quarters || undefined,
        types: modalState.types.length ? modalState.types : [OfferType.FLAT, OfferType.HOUSE]
    };
};
